import styled from 'styled-components';
import { deepResearchInfoIcon } from '../../commonImage';

export const AIContentVerification: React.FC = () => {
  return (
    <StyledContent>
      <div className='deep-research-warning-container'>
        <div className='deep-research-warning-content'>
          <span>
            <img src={deepResearchInfoIcon} alt='Info icon' />
          </span>
          <span>
            AI generated output may contain inaccuracies or errors. Verify output before use.
          </span>
        </div>
      </div>
    </StyledContent>
  );
};

const StyledContent = styled.div`
  .deep-research-warning-container {
    padding: 2rem 0px 0px 0px;
    .deep-research-warning-content {
      border: 1px solid #fcd9bc;
      background-color: #fcf5f0;
      color: #975100;
      border-radius: 4px;
      gap: 12px;
      border-width: 1px;
      padding-top: 6px;
      padding-right: 12px;
      padding-bottom: 6px;
      padding-left: 12px;
      display: flex;
      font-family: 'EYInterstate';
      font-weight: 400;
      font-style: normal;
      line-height: 20px;
      letter-spacing: 0;
      font-size: 12px;
    }
    .deep-research-warning-content span {
      display: flex;
    }
  }
`;

export default AIContentVerification;
